"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Favorite = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.9995,16.1943 C12.1595,16.1943 12.3205,16.2323 12.4665,16.3103 L16.9435,18.6643 L16.0885,13.6763 C16.0325,13.3533 16.1405,13.0223 16.3755,12.7923 L19.9995,9.2583 L14.9925,8.5323 C14.6665,8.4853 14.3845,8.2803 14.2395,7.9853 L11.9995,3.4483 L11.9985,3.4443 L9.7605,7.9853 C9.6155,8.2803 9.3335,8.4853 9.0075,8.5323 L3.9995,9.2593 L7.6245,12.7913 C7.8595,13.0223 7.9675,13.3533 7.9115,13.6763 L7.0565,18.6643 L11.5355,16.3093 C11.6805,16.2323 11.8395,16.1943 11.9995,16.1943 M16.9445,19.6653 C16.7865,19.6653 16.6265,19.6273 16.4785,19.5483 L11.9995,17.1943 L7.5205,19.5483 C7.1815,19.7263 6.7775,19.6983 6.4675,19.4713 C6.1575,19.2463 6.0055,18.8723 6.0705,18.4943 L6.9265,13.5063 L3.3025,9.9753 C3.0275,9.7083 2.9315,9.3143 3.0495,8.9503 C3.1675,8.5863 3.4775,8.3253 3.8565,8.2693 L8.8645,7.5423 L11.1035,3.0053 C11.4425,2.3173 12.5575,2.3173 12.8965,3.0053 L15.1355,7.5423 L20.1435,8.2693 C20.5225,8.3253 20.8325,8.5863 20.9505,8.9503 C21.0685,9.3143 20.9725,9.7083 20.6975,9.9753 L17.0745,13.5073 L17.9295,18.4943 C17.9945,18.8723 17.8425,19.2463 17.5325,19.4713 C17.3565,19.5993 17.1515,19.6653 16.9445,19.6653", fillRule: "evenodd" })));
};
Favorite.displayName = 'Favorite';
exports.default = Favorite;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Favorite.js.map